// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const defaultFormValue = () => ({
    lookingBack: null,
    lookingForward: null,
    conversationSummary: null,
});
